export default __webpack_public_path__ + "static/media/desires.88aa90fd.png";